/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */

/* NPM Imports Start */
import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getConfiguration } from '../../store/action/configurationAction';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';
import { hundread, thirtyFive } from './../../constant';
/* NPM Imports End */

/* Project Imports Start */
/* Project Imports End */

/* CCS & Image imports Start */
import HomeIcon from './../../assets/images/whiteIcon/HomeWhiteIcon.png';
import './header.scss';
/* CCS & Image imports End */
const Breadcrumbs = props => {
  const location = useLocation();
  const cookies = new Cookies();
  const user = useSelector(state => state.configuration.user);
  const sidebarres = useSelector(state => state);
  const {
    history,
    location: { pathname },
    menuTitle,
  } = props;
  const [pathnames, setpathnames] = useState([]);
  const [pageName, setPageName] = useState([]);
  const companyName = cookies.get('userdetails')
    ? cookies.get('userdetails').customers[0].companyName
    : null;
  const dispatch = useDispatch();
  useEffect(() => {
    if (cookies.get('token') && location.pathname === '/') {
      if (!user) {
        dispatch(getConfiguration());
      }
      if (user) {
        history.push(`/${user.replace('#', '')}`);
      }
    }
    if (cookies.get('token') && location.pathname === '#/') {
      if (!user) {
        dispatch(getConfiguration());
      }
      if (user) {
        history.push(`/${user.replace('#', '')}`);
      }
    }
  }, [location]);
  useEffect(() => {
    if (sidebarres.user.sidebardataresult) {
      _.forEach(sidebarres.user.sidebardataresult, function(value) {
        _.forEach(value.menuItems, function(item) {
          if (item.path === '#' + pathnames.toString()) {
            setPageName(item.menuname);
          }
        });
      });
    }
  }, [sidebarres, pathnames]);

  useEffect(() => {
    const pathArr = pathname.split('/').filter(x => x);
    if (menuTitle) {
      const lastpath = [];
      lastpath.push(_.last(pathArr));
      setpathnames(lastpath);
    } else {
      setpathnames(pathArr);
    }
  }, [pathname]);
  function text_truncate(str, length, ending) {
    if (length == null) {
      length = hundread;
    }
    if (ending == null) {
      ending = '';
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }

  return (
    <>
      {pathnames.length > 0 && menuTitle && (
        <span
          data-cy="H-HomeIcon-Link"
          onClick={() => history.push(`/${user.replace('#', '')}`)}>
          <img src={HomeIcon} />
        </span>
      )}

      {pathnames.map((name, index) => {
        const isLast = index === pathnames.length - 1;
        return isLast && !menuTitle ? (
          <div key={name}>
            <span id="companayName">
              {companyName ? text_truncate(companyName, thirtyFive) : null}
            </span>
          </div>
        ) : name === undefined ? (
          <span>{pageName}</span>
        ) : (
          <span key={name}>
            {' - '}
            {pageName}
          </span>
        );
      })}
    </>
  );
};
export default withRouter(Breadcrumbs);

Breadcrumbs.displayName = 'Breadcrumbs';

/* PropsTypes Validation Start*/
Breadcrumbs.propTypes = {
  history: PropTypes.any,
  location: PropTypes.any,
  menuTitle: PropTypes.bool,
};
/* PropsTypes Validation End*/

/* DefaultProps */
Breadcrumbs.defaultProps = {
  menuTitle: false,
};
/* DefaultProps */
